module.exports = __webpack_public_path__ + "static/media/cpu_logo.06bce7c1.png";